export default function TrustSection() {
  return (
    <section id="trust" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left - Main content */}
          <div className="lg:flex-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">
                Verified User Review
              </p>
            </div>

            <blockquote className="mb-6">
              <p className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold italic text-foreground-900 leading-relaxed">
                &ldquo;The OOPBuy Spreadsheet system completely changed how I approach product sourcing. Instead of spending hours manually comparing products, I now make data-driven decisions in minutes.&rdquo;
              </p>
            </blockquote>

            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-200 flex items-center justify-center">
                <span className="text-accent-700 font-semibold text-sm">JD</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-800">James Douglas</p>
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  <span className="text-xs text-foreground-500 ml-1">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Image */}
          <div className="lg:w-[38%] flex-shrink-0">
            <div className="w-full h-[320px] md:h-[400px] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20stylish%20entrepreneur%20in%20modern%20casual%20business%20attire%20standing%20in%20well-lit%20contemporary%20office%20space%20with%20product%20displays%20in%20background%2C%20warm%20natural%20lighting%2C%20friendly%20genuine%20expression%2C%20modern%20editorial%20photography%20style%2C%20soft%20shadows%2C%20neutral%20cream%20and%20warm%20beige%20tones%2C%20professional%20approachable%20aesthetic&width=800&height=800&seq=testimonial-portrait-v2&orientation=portrait"
                alt="Satisfied OOPBuy Spreadsheet user testimonial"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}